/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import List from '../../atoms/List';
//import { useDialog } from '../../atoms/Dialog';
import { Conversation, conversationsList } from '../../../api';
import useApi from '../../../hooks/useApi';
import LoadingContainer from '../../hoc/LodingContainer';
import Formatter from '../../../services/Formatter';


/*"messageInBgColor": "#091E2E",
"messageInTextColor": "#FFF",
"messageOutBgColor": "#00A3E0",
"messageOutTextColor": "#FFF",*/


function ConversationList() {
    const { data: convList, call: reload, ...loading } =
        useApi<Conversation[], void>(conversationsList('all', undefined, { autoFetch: true }));

    //const { openDialog } = useDialog();

    return (
        <>
            <h1>Konverzace</h1>

            <LoadingContainer {...loading} >
                {convList?.map(itm => (
                    <React.Fragment key={itm.sessionId}>
                        <div className='mt-32 w-100-bez-menu'>
                            {/* <List
                                title={itm.sessionId}
                                key={itm.sessionId}
                                columns={[
                                    { key: 'timestamp', label: 'Timestamp', formatuj: Formatter.reshuffleDateTimeSec },
                                    { key: 'answer', label: 'Odpověď' },
                                    { key: 'question', label: 'Otázka' },
                                ]}
                                rows={itm.conversationContent}
                                selectable='single'
                                selectedStr={itm.sessionId}
                                onLink={true}
                            /> */}
                        </div>
                    </React.Fragment>
                ))}
            </LoadingContainer>
        </>
    );
}

export default ConversationList;
